"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuNav = MenuNav;
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const styles_1 = require("../styles");
const useStyles = (0, styles_1.createUseThemeStyles)((theme) => ({
    nav: {
        display: "flex",
        flexDirection: "row",
        width: "100%",
        background: theme.palette.surface,
        borderRadius: "0.75rem",
        padding: "0.4rem",
        gap: "0.25rem",
        boxSizing: "border-box",
    },
    item: {
        "display": "flex",
        "flexDirection": "column",
        "alignItems": "center",
        "justifyContent": "center",
        "gap": "0.25rem",
        "flex": 1,
        "minWidth": 0,
        "padding": "0.5rem 0.25rem",
        "border": "none",
        "borderRadius": "0.5rem",
        "background": "transparent",
        "color": theme.palette.muted,
        "fontFamily": theme.typography.primary,
        "fontSize": "0.85rem",
        "cursor": "pointer",
        "transition": "color 150ms ease, background 150ms ease",
        "&:hover": {
            color: theme.palette.light.neutral,
        },
    },
    itemActive: {
        "color": theme.palette.primary.light,
        "&:hover": {
            color: theme.palette.primary.light,
        },
    },
    icon: {
        fontSize: "1.4rem",
        lineHeight: 1,
    },
    label: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        maxWidth: "100%",
    },
}));
function MenuNav({ items, active, onSelect, className, }) {
    const classes = useStyles();
    return (React.createElement("nav", { className: (0, classnames_1.default)(classes.nav, className) }, items.map((item) => (React.createElement("button", { key: item.key, type: "button", className: (0, classnames_1.default)(classes.item, {
            [classes.itemActive]: active === item.key,
        }), onClick: () => onSelect === null || onSelect === void 0 ? void 0 : onSelect(item.key) },
        React.createElement("span", { className: classes.icon }, item.icon),
        React.createElement("span", { className: classes.label }, item.label))))));
}
